import { render, staticRenderFns } from "./buy-item-product-list.vue?vue&type=template&id=d79d7970&scoped=true&"
import script from "./buy-item-product-list.vue?vue&type=script&lang=js&"
export * from "./buy-item-product-list.vue?vue&type=script&lang=js&"
import style0 from "./buy-item-product-list.vue?vue&type=style&index=0&id=d79d7970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79d7970",
  null
  
)

export default component.exports